export const notifications = state => state.items;
export const unreadCount = state => state.unreadCount;
export const notificationsLoading = state => state.isLoading;
